<div class="success-message-container" role="alert">
    <div class="success-message">
        <img src="assets/icons/check-green.svg" alt="" />
        <h2 class="title">Bestellung abgeschickt</h2>
        <div class="message">Der Warenkorb wurde bestellt. Sie werden automatisch zur Faro Suche geleitet</div>
        <div><a (click)="goToSearch()">Hier geht es zurück zur Faro Suche</a></div>
    </div>
</div>
